import { useContext, useMemo } from 'react';

import { PROMPT_EXCLUDED_VARIABLES } from '../constants';
import { EvaluatorStoreContext } from '../store/EvaluatorStoreProvider';
import { useEvaluatorStore } from '../store/evaluatorStore';
import { VarMappingProps } from '../types';
import { deserializeSchemaToFeedback } from './serializeFeedbackUIToLC';
import { useParsedManifest } from './useParsedManifest';

export function useVariableMappingProps(): VarMappingProps {
  const storeType = useContext(EvaluatorStoreContext);
  const availablePaths = useEvaluatorStore((state) => state.availablePaths);
  const variableMapping = useEvaluatorStore((state) => state.variableMapping);
  const setVariableMapping = useEvaluatorStore(
    (state) => state.setVariableMapping
  );
  const setActiveVariable = useEvaluatorStore(
    (state) => state.setActiveVariable
  );
  const promptTemplateFormat = useEvaluatorStore(
    (state) => state.promptTemplateFormat
  );
  const filteredAvailablePaths = useMemo(() => {
    if (promptTemplateFormat === 'f-string') {
      return availablePaths?.filter((path) => !path.includes('.')) ?? [];
    }
    return availablePaths;
  }, [promptTemplateFormat, availablePaths]);

  const { manifestStructuredSchema } = useParsedManifest('dataset-eval');
  const deserializedSchema = deserializeSchemaToFeedback(
    manifestStructuredSchema
  );
  const feedbackName = deserializedSchema?.name ?? 'score';

  const variableMappingProps = useMemo(
    () => ({
      variableMappings: variableMapping,
      availablePaths: filteredAvailablePaths,
      setVariableMappings: setVariableMapping,
      setActiveVariable,
      uneditableVariables: [...PROMPT_EXCLUDED_VARIABLES, feedbackName],
      storeType,
    }),
    [
      variableMapping,
      filteredAvailablePaths,
      setVariableMapping,
      setActiveVariable,
      feedbackName,
      storeType,
    ]
  );

  return variableMappingProps;
}
